import { ToggleButtonGroup } from "@mui/material";
import React from "react";
import AddIcon from "../../assets/icons/Add_icon.svg";
import { StyledToggleButton } from "../../molecules/ToggleButton";
const adresses = [
  {
    name: "John Paul",
    adress: [
      "Saint Marco 14, Rome",
      "Rome, Nomentano - 559944",
      "Mobile Number: +390664220484",
    ],
  },
  {
    name: "David Jhonson",
    adress: [
      "Saint Test 14, Rome",
      "Vanis, Nomentano - 559944",
      "Mobile Number: +390664220490",
    ],
  },
];

const ToggleCards = () => {
  const [selected, setSelected] = React.useState({});
  console.log("🚀 ~ ToggleCards ~ selected", selected);
  const handleValue = (e, value) => {
    if (value !== null) {
      setSelected(value);
    }
  };

  return (
    <div className="my-6 md:my-12 overflow-x-scroll md:overflow-x-auto p-4 ">
      <ToggleButtonGroup
        value={selected}
        exclusive
        onChange={handleValue}
        aria-label="text alignment"
      >
        {adresses.map((ads) => (
          <StyledToggleButton value={ads} className="w-[240px] md:w-auto ">
            <div className="mb-2 text-md md:text-xl text-dark font-bold">
              {ads.name}
            </div>
            {ads?.adress?.map((description, i) => (
              <div className="text-dark/70 text-sm md:text-base" key={i}>
                {description}
              </div>
            ))}
          </StyledToggleButton>
        ))}

        {/* ADD MORE */}
        <div className="cursor-pointer p-5 md:p-10 rounded-xl bg-grey/10 flex flex-col item-center justify-center">
          <img src={AddIcon} alt={"PCB play"} className="h-[25px] md:h-[35px]" />
          <p className="text-center text-dark/80 my-2 text-sm whitespace-nowrap	">add address</p>
        </div>
      </ToggleButtonGroup>
    </div>
  );
};

export default ToggleCards;
